import { render, staticRenderFns } from "./leftmenu.vue?vue&type=template&id=52eb0a67&scoped=true&"
import script from "./leftmenu.vue?vue&type=script&lang=js&"
export * from "./leftmenu.vue?vue&type=script&lang=js&"
import style0 from "./leftmenu.vue?vue&type=style&index=0&id=52eb0a67&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52eb0a67",
  null
  
)

export default component.exports